<div data-controller="info-box">
  <div class="info-button">&#x24D8;</div>

  <ul class="info-box">
  <li>Edit event information on the Settings page.
  <li>Add Studios, then add Professionals, Guests, and Students to Studios</li>
  <li>Review Dances, then add Heats and Solos to Students.
  <li>Define Agenda, then redo Heats.</li>
  <li>A form to assign back numbers to all leaders can be found on the Backs page.</li>
  <li>Publish when closer to the event.</li>
  <li>Enter scores from the judges pages.</li>
  </ul>
</div>
